import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { PageResolveGuard } from "./guards/page-resolve.guard";
import { JournalPostsResolveGuard } from "./guards/journal-posts-resolve.guard";
import { PageStyleguideComponent } from "./pages/page-styleguide/page-styleguide.component";
import { PageHomeComponent } from "./pages/page-home/page-home.component";
import { PagePressComponent } from "./pages/page-press/page-press.component";
import { PageJournalComponent } from "./pages/page-journal/page-journal.component";
import { PageJournalPostComponent } from "./pages/page-journal-post/page-journal-post.component";
import { JournalPostResolveGuard } from "./guards/journal-post-resolve.guard";
import { PageCareersComponent } from "./pages/page-careers/page-careers.component";
import { PageGiftCardsComponent } from "./pages/page-gift-cards/page-gift-cards.component";
import { PageAccessibilityComponent } from "./pages/page-accessibility/page-accessibility.component";

const routes: Routes = [
  {
    path: "",
    component: PageHomeComponent,
    resolve: {
      content: PageResolveGuard
    },
    children: [
      {
        path: "reservations",
        component: PageHomeComponent
      }
    ]
  },
  {
    path: "press",
    component: PagePressComponent,
    resolve: {
      content: PageResolveGuard
    }
  },
  {
    path: "journal",
    component: PageJournalComponent,
    resolve: {
      content: PageResolveGuard,
      posts: JournalPostsResolveGuard
    }
  },
  {
    path: "journal/:post",
    component: PageJournalPostComponent,
    resolve: {
      content: JournalPostResolveGuard
    }
  },
  {
    path: "careers",
    component: PageCareersComponent,
    resolve: {
      content: PageResolveGuard
    }
  },
  {
    path: "gift-cards",
    component: PageGiftCardsComponent,
    resolve: {
      content: PageResolveGuard
    }
  },
  {
    path: "accessibility-statement",
    component: PageAccessibilityComponent,
    resolve: {
      content: PageResolveGuard
    }
  },
  {
    path: "styleguide",
    component: PageStyleguideComponent
  },
  {
    path: "**",
    component: PageHomeComponent,
    resolve: {
      content: PageResolveGuard
    }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
